var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M12 24.002c6.629 0 12.002-5.373 12.002-12.001C24.002 5.373 18.629 0 12 0 5.373 0 0 5.373 0 12c0 6.629 5.373 12.002 12 12.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.114 11.773h9.726l.656-1.416H16.54l.013-.027 1.226-2.66a.704.704 0 0 0-.344-.933.707.707 0 0 0-.937.343l-1.5 3.25-.012.027h-5.97l-.013-.027-1.5-3.25a.706.706 0 0 0-1.28.59l1.226 2.66.012.027H6.147l-.654 1.416h2.624-.003ZM5.49 14.599h3.927l.026.06 1.914 4.155a.706.706 0 0 0 1.281 0l1.917-4.155.029-.06h3.254l.656-1.413H6.144l-.654 1.413Zm7.51.06-1 2.174-1.002-2.174-.027-.06h2.06l-.029.06h-.001Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 23.695,
    x2: -5.752,
    y1: 18.994,
    y2: 1.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CFFA2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVai);
export default __webpack_public_path__ + "static/media/vai.45498f768ba81ce3856057dc72cae452.svg";
export { ForwardRef as ReactComponent };